export default __webpack_public_path__ + "65bad8689ebcde1ef6c9487ecc62d12b.jpg";